// @flow
import Radio from 'common/domain/radio';
import User from 'common/domain/user';
import { SentryUser } from 'common/modules/session/domain/SentryUser';
import type { Session } from '../domain/Session';
import { RefreshToken } from '../domain/Session';

const REFRESH_TOKEN_KEY = 'RefreshToken';
const CURRENT_RADIO_KEY = 'CurrentRadio';
const SENTRY_USER_KEY = 'Sentry';

class SessionStorage {

  storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  retrieveNotExpired = (): ?Session => {
    const callSign = this.storage.getItem(CURRENT_RADIO_KEY);
    const refreshToken = RefreshToken.fromJson(this.storage.getItem(REFRESH_TOKEN_KEY));

    if (refreshToken && !refreshToken.isExpired()) {
      return { callSign, refreshToken };
    }

    this.clear();
    return undefined;
  }

  updateRefreshToken = (refreshToken: RefreshToken) => {
    this.storage.setItem(REFRESH_TOKEN_KEY, RefreshToken.toJson(refreshToken));
  }

  updateCurrentRadio = (radio: Radio) => {
    this.storage.setItem(CURRENT_RADIO_KEY, radio.callSign);
  }

  updateSentryUser = (user: User) => {
    this.storage.setItem(SENTRY_USER_KEY, JSON.stringify({
      email: user.email,
      language: user.language,
      username: `${user.name} ${user.surname}`,
    }));
  }

  retrieveSentryUser = (): ?SentryUser => {
    const storedUser = this.storage.getItem(SENTRY_USER_KEY);
    if (!storedUser) {
      return undefined;
    }

    return JSON.parse(storedUser);
  }

  clear = () => {
    this.storage.removeItem(REFRESH_TOKEN_KEY);
  }

}

export default new SessionStorage(window.localStorage);



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/session/services/SessionStorage.js